<script setup lang="ts">
import { formatDistance } from '@libs/utils';

import type { Distance } from '../../models';

interface ActivityDescriptionDistancesProps {
  distances: Distance[];
}

const props = defineProps<ActivityDescriptionDistancesProps>();
</script>

<template>
  <div class="activity-description-distances">
    <div class="title">
      {{ $t('planner.distances').toLocaleUpperCase() }}
    </div>
    <div
      v-for="distance in props.distances"
      :key="distance.description"
      class="distance"
    >
      <div>{{ distance.description }}</div>
      <div>{{ formatDistance(distance.distanceMeters) }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.activity-description-distances {
  margin-bottom: var(--spacing-32);

  .title {
    color: var(--color-soft-black);
    @include font-body-l-bold;
    margin: var(--spacing-12) 0;
    @include for-less-or-equal-than-900-px {
      @include font-body-m-bold;
    }
  }

  .distance {
    display: flex;
    justify-content: space-between;
    @include font-body-m-light;
    padding: var(--spacing-12) 0;
    @include for-less-or-equal-than-900-px {
      @include font-body-s-light;
    }
  }
}
</style>
